var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-up',{attrs:{"match-id":_vm.matchId,"team-id":_vm.teamId,"team-type":_vm.teamType,"actions":_vm.actions,"data":_vm.data,"edit":_vm.edit}})}
var staticRenderFns = []
export { render, staticRenderFns }